import { RevxSkeleton } from 'components';
import {
  JobAdjustmentStatusEnum,
  JobItem,
  JobTypeEnum,
  JobWorkflowStatusEnum,
  PDF_TEMPLATE_ENUM,
} from 'domains/workspaceDomain';
import { CommonJobAdjustmentLink, CommonJobRevision } from '../../common';
import CommonJobHistoryAdjustmentLink from '../JobAdjustmentLink/HistoryLink';
import Summary from './Summary';
import useJobCardTabSummary from '../../../../hooks/useJobCardTabSummary';
import { RevxButton } from 'components/RevxButton';
import { toast } from 'components/RevxMessage';
import { Trans, useTranslation } from 'react-i18next';
import workspaceService from 'services/jobService';
import { useAppDispatch } from 'app/hooks';
import { useGetJobCountHandler } from 'hooks';
import useJobCardInfo from '../../../../hooks/useJobCardInfo';

const CommonSummary = (jobData: JobItem) => {
  const { summary, loading, revisionList } = useJobCardTabSummary(jobData.id);
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const getJobCount = useGetJobCountHandler();
  const { hasProducer } = useJobCardInfo(jobData);

  const poAccept = async () => {
    const res = await dispatch.workspaceDetail.poAccept(jobData);
    dispatch.workspace.reloadJobList();
    if (res !== null) {
      toast(
        <Trans
          i18nKey="toast.poAccepted"
          components={{
            a: (
              <a
                target="_blank"
                rel="noreferrer"
                href={workspaceService.getPdfLink({
                  jobId: jobData.id,
                  jobConfigId: jobData.quoteId,
                  template:
                    jobData.jobType === JobTypeEnum.NETWORK
                      ? PDF_TEMPLATE_ENUM.JOB_TICKET_REVSHOP
                      : PDF_TEMPLATE_ENUM.JOB_TICKET_SUPPLIER,
                })}
              >
                h
              </a>
            ),
          }}
        />
      );
    }
    getJobCount();
  };

  const poDecline = async () => {
    await dispatch.workspaceDetail.poDecline(jobData);
    dispatch.workspace.reloadJobList();
    getJobCount();
  };
  return (
    <div className="new-summary-wrap">
      <RevxSkeleton loading={loading}>
        <Summary summary={summary} jobData={jobData} />
        {jobData.adjustmentStatus !== JobAdjustmentStatusEnum.NONE && (
          <CommonJobAdjustmentLink jobData={jobData} />
        )}
        {summary?.historyAdjustments && summary.historyAdjustments.length > 0 && (
          <div style={{ padding: '0 20px 20px 100px' }}>
            {summary.historyAdjustments
              .sort(
                (a, b) =>
                  new Date(b.adjustedAt).getTime() -
                  new Date(a.adjustedAt).getTime()
              )
              .map((adj) => (
                <CommonJobHistoryAdjustmentLink
                  key={adj.adjustmentId}
                  jobData={jobData}
                  adjustment={adj}
                />
              ))}
          </div>
        )}
        <CommonJobRevision revisionList={revisionList} />
        {hasProducer && (
          <div
            className="action"
            hidden={
              !(
                jobData.workflowStatus === JobWorkflowStatusEnum.PO_SENT ||
                jobData.workflowStatus === JobWorkflowStatusEnum.PO_READ
              )
            }
          >
            <RevxButton type="primary" onClick={() => poAccept()}>
              {t('workspace.detail.po.acceptPO')}
            </RevxButton>

            <RevxButton onClick={() => poDecline()}>
              {t('workspace.detail.po.declinePO')}
            </RevxButton>
          </div>
        )}
      </RevxSkeleton>
    </div>
  );
};

export default CommonSummary;
